// extracted by mini-css-extract-plugin
module.exports = {"lightGrey":"rgba(186,187,194,.8)","darkGreyBlue":"#29434e","white":"#fff"};